import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Header, Footer } from '../components/layout';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { ConnectionConsent } from '../features/plugin/ConnectionConsent';

const ConsentFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { direction, t } = useLanguage();
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
      <Header />
      <main dir={direction} className="flex-1 flex items-center justify-center p-4 sm:p-6 my-8">
        <section aria-labelledby="consent-title" className="w-full max-w-md rounded-2xl bg-white dark:bg-slate-900 shadow-xl p-6 sm:p-8 text-slate-900 dark:text-slate-100">
          <h1 id="consent-title" className="text-2xl font-bold tracking-tight mb-6">{t('plugin.title')}</h1>
          {children}
        </section>
      </main>
      <Footer />
    </div>
  );
};

export const PluginConsentPage: React.FC = () => {
  const { user, tokens, isAuthenticated, isLoading } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();
  const match = /^#request=([A-Za-z0-9_-]{1,512})$/.exec(location.hash);
  const requestToken = match?.[1];
  if (requestToken && !isLoading && !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: { pathname: location.pathname + location.hash } }} />;
  }
  return (
    <ConsentFrame>
      {!requestToken ? <p role="alert">{t('plugin.expired')}</p>
        : isLoading ? <p role="status">{t('plugin.loading')}</p>
        : <ConnectionConsent key={user?.id + ':' + tokens?.accessToken + ':' + requestToken} requestToken={requestToken} />}
    </ConsentFrame>
  );
};
